var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vbt-content-box',{attrs:{"loading":_vm.loading,"loading-error":_vm.loadingError,"no-content":_vm.noContent,"title":"History"}},[_c('vbt-table',{attrs:{"headers":_vm.headers,"items":_vm.packageReturnHistory,"show-paginator":""},scopedSlots:_vm._u([{key:"processDate",fn:function(ref){
var _date = ref.item.processDate;
return [_vm._v(" "+_vm._s(_vm.formatDate(_date))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }